import React from 'react'
import EodShapedQueue from '../shared/EodShapedQueue'

// The heavy EOD jobs, run one at a time. The queue can hold more than one kind
// of job, so the row's name is what says which task failed.
const BackgroundTasksQueue = () => (
    <EodShapedQueue
        queue="background-tasks"
        title="Background Tasks"
        depthText="heavier outlet task(s) still queued or running — they run one at a time, so a short backlog is normal during the evening EOD window."
        failedText="outlet task(s) did not finish. Check the job name on each row for which task it was."
    />
)

export default BackgroundTasksQueue
